export default __webpack_public_path__ + "static/media/C2QB_white_btn_lg_default.229076fe.png";